<template>
<div v-bind:class="Fullscreen">
  <div class="row">
    <div class="col-12">
      <div class="card card-bottom-radius-8">
        <div class="card-header text-third" style="display: flex; justify-content: space-between; align-items: center;" v-if="showHeader">
          <slot name="return"></slot>
          <div style="display: flex; gap: 0.5rem;">
            <small v-show="showPaging">{{$lang.Common.DataTable.RecordsShow}}</small>
            <select class="mb-2 mb-sm-0" style="border: solid 1px #d9d9d9;" v-model="cbxItemPerPage" v-on:change="ReloadCountPage()" v-show="showPaging">
              <option value="5">5</option>
              <option value="10" selected>10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <small v-show="showPaging">{{$lang.Common.DataTable.Records}}</small>
          </div>
          <div v-if="newHeaderStatus" class="Ajuste-Buton-Template">
            <slot name="ButtonsAprova"></slot>
          </div>
          <div v-else class="card-actions d-flex">
            <slot name="header-card-actions"></slot>
            <a href="javascript:void(0);" v-show="showSearch" v-b-tooltip.hover :title="$lang.Common.Buttons.Search" v-on:click="Search">
              <i class="fas fa-search text-third"></i>
            </a>
            <a href="javascript:void(0);" class="d-md-down-none" v-show="showHistory" v-b-tooltip.hover :title="$lang.Common.Buttons.History" v-on:click="ShowHistory">
              <i class="fas fa-history text-third"></i>
            </a>
            <a href="javascript:void(0);" class="d-md-down-none" v-show="showPrint" v-b-tooltip.hover :title="$lang.Common.Buttons.Print" v-on:click="Print">
              <i class="fas fa-print text-third"></i>
            </a>
            <a href="javascript:void(0);" class="d-md-down-none" v-show="showExportExcel" v-b-tooltip.hover :title="$lang.Common.Buttons.ExportExcel" v-on:click="ExportExcel">
              <i class="fas fa-file-excel text-third"></i>
            </a>
            <a href="javascript:void(0);" class="d-md-down-none" v-show="showDownload" v-b-tooltip.hover :title="$lang.Common.Buttons.Download" v-on:click="SaveFile">
              <i class="fas fa-download text-third"></i>
            </a>
            <a href="javascript:void(0);" class="d-md-down-none" v-show="showFullscreen" v-on:click="Fullscreen" >
              <i class="fas fa-expand-arrows-alt text-third bold" v-show="setFullscreen" v-b-tooltip.hover :title="$lang.Common.Buttons.Fullscreen"></i>
              <i class="fas fa-compress-arrows-alt text-third bold" v-show="!setFullscreen" v-b-tooltip.hover :title="$lang.Common.Buttons.ExitFullscreen"> </i>
            </a>
            <a href="javascript:void(0);" class="d-md-down-none" v-show="showClose" v-on:click="$emit('Closed')" v-b-tooltip.hover :title="'Fechar'">
              <i class="fa fa-times-circle"></i>
            </a>
            <a href="javascript:void(0);" v-show="showShare"  v-b-tooltip.hover :title="'Compartilhar'">
              <i class="fas fa-user-friends text-third"></i>
            </a><a href="javascript:void(0);" v-show="getShowDelete"  v-b-tooltip.hover :title="'Excluir'" v-on:click="DeleteFile">
              <i class="fa fa-trash text-danger pr5"></i>
            </a>
            <a href="javascript:void(0);" v-show="showSettings" v-b-tooltip.hover :title="'Configurações'">
              <i class="fas fa-cogs text-third"></i>
            </a>
            <a href="javascript:void(0);" v-show="showReload" v-b-tooltip.hover :title="'Recarregar'" v-on:click="$emit('Reload')">
              <i class="fas fa-sync-alt text-third"></i>
            </a>
          </div>
        </div>
        <div>
          <slot name="formBeforeTable"></slot>
        </div>
        <div class="card-block table-responsive">
        <!-- <div v-bind:class="[ showHeader ? 'card-block table-responsive' : 'table-responsive' ]"> -->
          <!-- grid-sticky: opt-in por TELA (prop stickyHeader). Envolve SO a <table>, para a
               paginacao e o contador ficarem FORA da area que rola — antes eles rolavam junto com
               as linhas. A altura sai de `ajustaAlturaGrid`, medida contra o `.app-body`, que e
               quem rola a tela. Sem a prop este div e inerte: sem classe, sem overflow, sem altura. -->
          <div :class="{ 'grid-sticky': stickyHeader }" ref="scrollGrid">
          <table class="table table-hover" style="border: 1px solid #dcdede;">
          <!-- <table class="table table-hover" v-bind:style="[ showHeader ? 'border: 1px solid #dcdede;' : '' ]"> -->
            <thead class="thead-third" v-if="columns">
              <slot name="header"></slot>
              <tr>
                <th v-on:change="$emit('check', $event.target)" v-if="showCheckInput"><input type="checkbox" class="check-Despesa"></th>
                <th :class="th_class" v-for="colTitle in columns" v-bind:key="colTitle"><span v-html="colTitle"></span></th>
                <th class="add-popup" v-on:click="$emit('Popup', obj)" v-if="showAdd" v-b-tooltip.hover :title="'Adicionar novo cadastro'"><i class="fas fa-plus"></i><span>ADICIONAR</span></th>
              </tr>
            </thead>
            <thead class="thead-third" v-if="columnsLeft">
              <slot name="header2"></slot>
              <tr>
                <th v-on:change="$emit('check', $event.target)" v-if="showCheckInput"><input type="checkbox" class="check-Despesa"></th>
                <th :class="th_class_left" v-for="colTitle in columnsLeft" v-bind:key="colTitle"><span v-html="colTitle"></span></th>
                <th class="add-popup" v-on:click="$emit('Popup', obj)" v-if="showAdd" v-b-tooltip.hover :title="'Adicionar novo cadastro'"><i class="fas fa-plus"></i><span>ADICIONAR</span></th>
              </tr>
            </thead>
            <thead class="thead-third" v-else>
              <slot name="thead"></slot>
            </thead>
            <tbody>
              <tr v-show="total <= 0 && !loading && showPaging">
                <td :colspan="999" class="text-center">{{$lang.Common.DataTable.NoRecordsFound}}</td>
              </tr>
              <tr v-show="loading">
                <td :colspan="999" class="text-center" style="padding: 74px 0px 74px">
                  <h3 class="text-secondary">{{$lang.Common.Loading}}!</h3>
                  <img :src="ImgLoading" alt="Loading" style="width: 32px;"/>
                </td>
              </tr>
              <slot></slot>
            </tbody>
            <tfoot>
              <slot name="tfoot"></slot>
            </tfoot>
          </table>
          </div><!-- /grid-sticky: paginacao e contador ficam FORA da area que rola -->
          <nav aria-label="Page navigation example" v-show="showPaging">
            <ul class="pagination pagination-sm pt-2">
              <li class="page-item" v-bind:class="ActivePrevious">
                <a class="page-link" href="javascript:void(0);" tabindex="-1" v-on:click="PagingPrevious()">{{$lang.Common.DataTable.Previous}}</a>
              </li>
              <li class="page-item" v-for="index in (totalPages)" v-bind:key="index" v-bind:class="ActivePage(index)" v-on:click="LoadPage(index)" v-if="(index > 0) && (index >= currentPage - 4) && (index <= currentPage + 4)">
                <a v-if="index < 10" class="page-link" href="javascript:void(0)">0{{ index }}</a>
                <a v-else class="page-link" href="javascript:void(0)">{{ index }}</a>
              </li>
              <li class="page-item" v-bind:class="ActiveNext">
                <a class="page-link" href="javascript:void(0);" v-on:click="PagingNext()">{{$lang.Common.DataTable.Next}}</a>
              </li>
            </ul>
          </nav>
          <div v-show="showPaging"><small>{{ShowDisplayingPaging}}</small></div>
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
  <TableEditMessage :showMessage="showTipFooter" :message="messageTipFooter"/>
</div>
</template>
<script>
import TableEditMessage from './TableEditMessage'

export default {
  name: 'Tables',
  data () {
    return {
      pagingIndex: 1,
      pagingLimit: this.pagingLimitDefault,
      totalPages: 0,
      total: 0,
      startTotal: 0,
      cbxItemPerPage: this.pagingLimitDefault,
      objList: null,
      currentPage: 1,
      loading: false,
      setFullscreen: true,
      ImgLoading: '/static/img/loader.gif'
    }
  },
  components: {
    TableEditMessage
  },
  mounted () {
    this.$emit('tableMounted')
    if (this.stickyHeader) {
      this.ajustaAlturaGrid()
      window.addEventListener('resize', this.ajustaAlturaGrid)
    }
  },
  beforeDestroy () {
    if (this.stickyHeader) window.removeEventListener('resize', this.ajustaAlturaGrid)
  },
  updated () {
    // a grid troca de conteudo (pagina, filtro, aba) sem remontar
    if (this.stickyHeader) this.ajustaAlturaGrid()
  },
  props: {
    // Mantem o cabecalho da grid visivel enquanto o corpo rola. Opt-in: so as telas que passam
    // a prop mudam de comportamento.
    stickyHeader: {
      type: Boolean,
      required: false,
      default: false
    },
    columns: {
      type: Array,
      required: false
    },
    columnsLeft: {
      type: Array,
      required: false
    },
    th_class: {
      type: String,
      required: false,
      default: 'text-center'
    },
    th_class_left: {
      type: String,
      required: false,
      default: 'text-left'
    },
    showSearch: {
      type: Boolean,
      required: false
    },
    showPrint: {
      type: Boolean,
      required: false
    },
    showExportExcel: {
      type: Boolean,
      required: false
    },
    showDownload: {
      type: Boolean,
      required: false
    },
    showFullscreen: {
      type: Boolean,
      required: false
    },
    showTipFooter: {
      type: Boolean,
      required: false,
      default: true
    },
    showButtonNew: {
      type: Boolean,
      required: false,
      default: false
    },
    messageTipFooter: {
      type: String,
      required: false
    },
    showClose: {
      type: Boolean,
      required: false,
      default: false
    },
    showPaging: {
      type: Boolean,
      required: false,
      default: true
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: true
    },
    showHistory: {
      type: Boolean,
      required: false
    },
    showShare: {
      type: Boolean,
      required: false
    },
    showCheckInput: {
      type: Boolean,
      required: false
    },
    showDelete: {
      type: Boolean | Function,
      required: false
    },
    showSettings: {
      type: Boolean,
      required: false
    },
    showReload: {
      type: Boolean,
      required: false
    },
    pagingLimitDefault: {
      type: Number,
      default: 10,
      required: false
    },
    newHeaderStatus: {
      type: Boolean,
      default: false,
      required: false
    },
    showAdd: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    ActivePrevious: function () {
      if (this.pagingIndex <= 1) {
        return 'disabled'
      } else {
        return ''
      }
    },
    ActiveNext: function () {
      if (this.currentPage >= this.totalPages) {
        return 'disabled'
      } else {
        return ''
      }
    },
    ShowRecordStart: function () {
      if (this.currentPage <= 1) {
        return this.currentPage
      } else {
        return (this.currentPage * this.pagingLimit) - this.pagingLimit + 1
      }
    },
    ShowTotalPagedRecord: function () {
      if (this.currentPage >= this.totalPages) {
        return this.total
      } else {
        return this.currentPage * this.pagingLimit
      }
    },
    ShowDisplayingPaging: function () {
      var msg = this.$lang.Common.DataTable.MessageDisplayingRecords.replace('@START@', this.ShowRecordStart)
      msg = msg.replace('@END@', this.ShowTotalPagedRecord)
      msg = msg.replace('@TOTAL@', this.total)
      return msg
    },
    getShowDelete () {
      return typeof this.showDelete === 'function' ? this.showDelete() : this.showDelete
    }
  },
  methods: {
    // Deixa a grid com a altura exata que sobra, para existir UM scroll so: o dela.
    //
    // O detalhe que fez isso falhar tres vezes antes: quem rola a tela NAO e o documento, e o
    // `div.app-body` do layout do CoreUI. Ele tem `overflow-x: hidden`, e overflow-x diferente de
    // visible faz o browser computar `overflow-y: auto` — o mesmo mecanismo do `.table-responsive`.
    // Medir `document.scrollHeight` era medir o elemento errado, e por isso a conta nunca fechava.
    //
    // Tambem nao da para trocar tudo por sticky na viewport: entre o <th> e o `.app-body` ha
    // `main.main` com `overflow: hidden`, que captura o sticky num container que nao rola (medido:
    // o cabecalho ia para -415 ao rolar). O scroll proprio da grid nao e efeito colateral, e o
    // mecanismo.
    ajustaAlturaGrid () {
      const el = this.$refs.scrollGrid
      if (!el) return
      // Piso baixo de proposito: a decisao foi fechar o scroll de fora em TODA resolucao, mesmo
      // que em tela baixa sobrem poucas linhas por vez. Com piso 220 as telas de 1366x768 e
      // 1280x720 continuavam rolando 120 e 204px (medido).
      // PISO e FOLGA saem junto com o calculo: sem eles o eslint reprova por no-unused-vars.

      // Com a altura LIMPA, o fim do <body> é o fim real do conteúdo — inclusive o que está fora
      // do card. Não serve `scrollHeight` de ninguém: o do documento tem piso na viewport, e o do
      // `.app-body` engana porque ele CRESCE com o conteúdo em vez de rolar quando a lista é
      // grande (medido: com 102 linhas ele ficou com 4467px e `scrollHeight - clientHeight = 0`).
      el.style.maxHeight = ''

      // TESTE (Rodrigo, 2026-09-16): grid sem teto de altura. Desfaz a decisao descrita no
      // comentario acima — volta o scroll da PAGINA no lugar do scroll interno da grid.
      // el.style.maxHeight = Math.max(altura, PISO) + 'px'
    },
    limpaCheckDespesa () {
      var checkbox = document.querySelector('.check-Despesa')
      if (checkbox.checked) {
        checkbox.checked = false
      }
    },
    Clear () {
      this.objList = null
      this.$parent.objList = null
      this.pagingIndex = 1
      this.pagingLimit = this.pagingLimitDefault
      this.totalPages = 0
      this.startTotal = 0
      this.cbxItemPerPage = this.pagingLimit
      this.currentPage = 1
      this.total = 0
    },
    LoadAll () {
      this.$emit('Load')
    },
    LoadStartTotalGrid (total) {
      this.total = total
    },
    LoadAllByData (response) {
      this.objList = null
      this.$parent.objList = null
      this.loading = true

      if (response) {
        var result = response.data

        if (parseInt(result.code) >= 0) {
          this.objList = result.data
          this.$parent.objList = result.data
          this.total = result.count
          this.totalPages = result.totalPages
          this.pagingIndex = result.pagingIndex
          this.pagingLimit = result.pagingLimit
        }
      } else {
        this.totalPages = 0
        this.total = 0
      }
      this.loading = false
    },
    PagingNext () {
      var index = this.pagingIndex + 1
      if (this.currentPage < this.totalPages) {
        this.pagingIndex = index
        this.currentPage = this.currentPage + 1
        this.LoadAll()
        document.activeElement.blur()
      }
    },
    PagingPrevious () {
      var index = this.pagingIndex - 1
      if (this.currentPage > 1) {
        this.pagingIndex = index
        this.currentPage = this.currentPage - 1
        this.LoadAll()
        document.activeElement.blur()
      }
    },
    ActivePage (index) {
      if (index === this.currentPage) {
        return 'disabled'
      } else {
        return ''
      }
    },
    LoadPage (index) {
      this.currentPage = index
      this.pagingIndex = index // - 1
      if (this.currentPage >= 1 && this.currentPage <= this.totalPages) {
        this.LoadAll()
        document.activeElement.blur()
      }
    },
    ReloadCountPage () {
      this.pagingLimit = this.cbxItemPerPage
      this.pagingIndex = 1
      this.currentPage = 1
      this.LoadAll()
      this.$emit('ChangePagingLimit', this.pagingLimit)
    },
    Search () {
      this.$emit('Search')
    },
    Print () {
      /*
      // variable to hold all the css that we extract
      var css = ''
      var styletags = document.getElementsByTagName('style')

      // loop over all the style tags
      for (var i = 0; i < styletags.length; i++) {
        // extract the css in the current style tag
        css += styletags[i].innerHTML
      }

      var currentsheet = false // initialise a variable to hold a reference to the stylesheet we are currently extracting from
      // loop over all the external stylesheets
      for (i = 0; i < document.styleSheets.lenngth; i++) {
        currentsheet = document.styleSheets[i]
        // loop over all the styling rules in this external stylesheet
        for (var e = 0; e < currentsheet.cssRules.length; e++) {
          // extract all the styling rules
          css += currentsheet.cssRules[e].cssText
        }
      }

      var headstr = '<!DOCTYPE html><html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"><meta name="robots" content="noindex, nofollow"><title>ZSistema :: Impressão</title><link type="text/css" rel="stylesheet" media="print" href="//unpkg.com/bootstrap/dist/css/bootstrap.min.css"/><link href="static/css/style.min.css?1001" rel="stylesheet" media="print"><style>@media print \n{\n' + css + '\n body{ padding: 2px;} \n}</style></head>'
      var footstr = '</body>'
      var content = '<table class="table" style="border: 1px solid rgb(220, 222, 222);">' + this.$el.children['0'].children['0'].childNodes['0'].childNodes[2].children['0'].innerHTML + '</table>'
      var print = window.open('about:blank')

      print.document.write(headstr + content + footstr)
      print.window.print()
      print.window.close()
      */
      this.$emit('Print')
    },
    ExportExcel () {
      this.$emit('ExportExcel')
    },
    SaveFile () {
      this.$emit('SaveFile')
    },
    DeleteFile () {
      this.$emit('DeleteFile')
    },
    Fullscreen () {
      if (this.setFullscreen) {
        this.setFullscreen = false
      } else {
        this.setFullscreen = true
      }
      this.$emit('Fullscreen')
    },
    ShowHistory () {
      this.$emit('History')
    }
  }
}
</script>

<style scoped>
th {
  text-align: center;
}

/* Cabecalho que acompanha a rolagem. Ligado so pela prop `stickyHeader`.
   `position: sticky` no <thead> nao funciona no Chrome/Safari com `border-collapse: collapse`
   (que o .table do Bootstrap usa), entao gruda nos <th> — que e o que a spec suporta.
   O `top: 0` e relativo ao .grid-sticky, nao a viewport: quem rola e este wrapper. */
/* A altura vem de `ajustaAlturaGrid`, inline. Um `calc(100vh - <numero>)` nao serve: o topo da
   grid muda por tela (filtro, abas e o cartao de status tem alturas diferentes) e ha conteudo
   abaixo dela. Aqui fica so o que e fixo. */
/* TESTE (Rodrigo, 2026-09-17): o teto saiu de `ajustaAlturaGrid`, e o sticky morre junto.
   `position: sticky` gruda no scroll container mais proximo — que era ESTE wrapper, e ele so
   rolava porque tinha `max-height`. Sem teto ele cresce com a lista e nunca rola, entao o <th>
   nao tem contra o que grudar: sai de cena com a pagina. Nao adianta cair pro proximo ancestral,
   porque `.table-responsive` (overflow-x: auto, sem altura) e `main.main` (overflow: hidden) sao
   scroll containers que tambem nao rolam — e do `main.main` veio o cabecalho indo pra -415 na
   tentativa antiga, registrada em `ajustaAlturaGrid`.
   Sem o teto so ha duas saidas, e as duas precisam de decisao: devolver o teto nas 8 telas que
   pedem `stickyHeader`, ou destravar o `overflow` do `main.main` (layout do CoreUI inteiro).
   Ate la o wrapper fica INERTE de verdade: com `overflow-y: auto` ele ainda era um contexto de
   scroll que clipa o que sai da tabela, sem entregar nada em troca. */
.grid-sticky {
  /* overflow-y: auto; */
}
/* O fundo mora no <thead> (.thead-third), e o thead NAO e sticky — so os <th> sao. Sem fundo
   proprio o <th> fica transparente e as linhas passam por baixo dele ao rolar (medido: o corpo
   aparecia atravessando os rotulos). `inherit` copia a cor do PAI DIRETO, entao precisa dos dois
   degraus: thead -> tr -> th. So no <th> nao adianta, porque o <tr> e transparente. */
.grid-sticky >>> thead tr {
  background-color: inherit;
}
.grid-sticky >>> thead th {
  /* position: sticky; top: 0; z-index: 2; — ver o bloco acima: sem teto nao ha o que grudar. */
  background-color: inherit;
}
#btn-Add{
  height: 100%;
  width: 200px;
  background: #008cff;
  color: white;
  font-weight: bold;
  border-radius: 7px;
}
#btn-Add:hover{
  background: #036abe;
}
#btn-Reprov{
  height: 100%;
  width: 75px;
  background: red;
  color: white;
  font-weight: bold;
  border-radius: 7px;
}
#btn-Reprov:hover{
  background: rgb(160, 0, 0);
}
.card-header {
  height: 45px;
}
.Ajuste-Buton-Template {
  /* position: absolute; */
  gap:1rem;
}
.add-popup{
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 0.5rem;
  border: 0
}

</style>



// WEBPACK FOOTER //
// src/components/forms/Tables.vue